<div class="payment-info">
  <h4 translate>CHECKOUT.PAYMENT_METHOD</h4>
  <div class="card-info">
    <img src="assets/images/knet-logo.svg" alt="Knet Logo" />
    <span translate>LEARN_MORE_PAGE.KNET </span>
  </div>
  <div class="card-info">
    <img src="assets/images/default-card.svg" alt="Default Logo" />
    <span translate>LEARN_MORE_PAGE.CREDIT_CARD</span>
  </div>
  @if (type === 'withtaly') {
    <div class="card-info">
      <img src="assets/images/add-card-taly-logo.svg" alt="Taly Logo" />
      <span translate>LEARN_MORE_PAGE.SPLIT_INTO</span>
    </div>
  }
</div>
